'use client';

import Link from 'next/link';
import styles from './RelatedContentCard.module.scss';

export interface RelatedContentItem {
  title: string;
  description: string;
  href: string;
  image?: string;
}

export interface RelatedContentCardProps {
  item: RelatedContentItem;
  className?: string;
}

export function RelatedContentCard({ item, className = '' }: RelatedContentCardProps) {
  return (
    <Link href={item.href} className={`${styles.card} ${className}`}>
      {item.image && (
        <div className={styles.imageWrapper}>
          <img src={item.image} alt={item.title} loading="lazy" />
          <div className={styles.imageOverlay} />
        </div>
      )}
      <div className={styles.content}>
        <h3 className={styles.title}>{item.title}</h3>
        <p className={styles.description}>{item.description}</p>
        <span className={styles.arrow}>→</span>
      </div>
    </Link>
  );
}

export default RelatedContentCard;